import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from '@configs/axios';

const operations = {
    getNotificationList: createApiService(
        (page = 1, query = '', lang) => {
            const reqQuery = `?page=${page}&query=${query}`;
            return axios.get(`/notifications/index${reqQuery}`, {
                headers: { 'x-lang': `${lang}` }
            });
        },
        { ...API_CONFIGS.GET_WITH_DATA, context: 'Notification - Get List' }
    ),

    getUnReadNotificationList: createApiService(
        (lang) => {
            return axios.get('/notifications/unread', {
                headers: { 'x-lang': `${lang}` }
            });
        },
        { ...API_CONFIGS.GET_WITH_DATA, context: 'Notification - Get Unread' }
    ),

    readAll: createApiService(
        (lang) => {
            return axios.get('/notifications/readall', {
                headers: { 'x-lang': `${lang}` }
            });
        },
        { ...API_CONFIGS.GET_OPTIONAL_DATA, context: 'Notification - Read All' }
    )
}

export default operations